// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f0aa8c72","732":"c3dce1b0","977":"1a212f80"}[chunkId] + ".chunk.js";
};